module.exports = __webpack_public_path__ + "eb73d96d7ad1c0a4f23dc115e09fae24.svg";